"use strict";
import axios from 'axios'
import alert from './alert'
// import el from 'element-ui'
import qs from 'qs'
var common = {};

(function (_) {
    _.isMobile = function (str) {
        str = str || '';
        return /^0?1[0-9]{2}\d{8}$/.test(str);
    };
    _.request = function (param) {
        return new Promise((resolve, reject) => {
            axios({
                method: 'POST',
                url: param.url,
                baseURL: _.apiUrl(),
                data: qs.stringify(param.data || {}),
                headers: _.getRequestHeader()
            }).then(res => {
                if (res && res.status === 200) {
                    var data = res.data;
                    if (data && data.response && data.response.code === 0) {
                        resolve(data.response);
                    } else {
                        if (param.customErrorEvent) {
                            reject(data)
                        } else {
                            _.defaultSuccessHandle(data);
                        }
                    }
                }
            }).catch(xhr => {
                _.defaultErrorHandle(xhr)
            })
        })
    };
    _.uploadFile = function (param) {
        return new Promise((resolve, reject) => {
            axios.post(_.apiUrl() + '/basis/uploadFile', param.data, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'X-Access-Platform': 4,
                    'X-Access-AccountType': 0
                }
            }).then(res => {
                if (res && res.status === 200) {
                    var data = res.data;
                    if (data && data.response && data.response.code === 0) {
                        resolve(data.response);
                    } else {
                        if (param.customErrorEvent) {
                            reject(data)
                        } else {
                            _.defaultSuccessHandle(data);
                        }
                    }
                }
            }).catch(xhr => {
                _.defaultErrorHandle(xhr)
            })
        })
    };
    _.checkMemberLogin = function (page) {
        var loginInfo = _.getMemberLogin();
        if (loginInfo) {
            return
        }
        localStorage.setItem('returnPage', page.$route.path);
        page.$router.push('/login/1');
    }
    _.getMemberLogin = function () {
        var loginInfo = localStorage.getItem('loginInfo') || '';
        var now = new Date().getTime()
        if (loginInfo) {
            loginInfo = JSON.parse(loginInfo)

            console.log((now - loginInfo.timeStamp) / 1000 / 60)
            if (((now - loginInfo.timeStamp) / 1000 / 60) > 60) {
                localStorage.removeItem('loginInfo')
                loginInfo = ''
            }
        }
        return loginInfo
    };
    _.formatDate = function (time, format) {
        if (typeof time === 'string') {
            time = time.replace(/-/g, '/').replace(/T/g, ' ');
            if (time.indexOf('.') > 0) {
                time = time.substring(0, time.indexOf('.'));
            }
            time = new Date(time);
        }
        var o = {
            'M+': time.getMonth() + 1, //month
            'd+': time.getDate(), //day
            'H+': time.getHours(), //hour
            'm+': time.getMinutes(), //minute
            's+': time.getSeconds(), //second
            'q+': Math.floor((time.getMonth() + 3) / 3), //quarter
            'S': time.getMilliseconds() //millisecond
        };
        if (/(y+)/.test(format)) {
            format = format.replace(RegExp.$1, (time.getFullYear() + '').substr(4 - RegExp.$1.length));
        }
        for (var k in o) {
            if (new RegExp('(' + k + ')').test(format)) {
                format = format.replace(RegExp.$1, RegExp.$1.length === 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length));
            }
        }
        return format;
    };
    _.getRequestHeader = function () {
        var header = {};
        var loginInfo = _.getMemberLogin();
        if (loginInfo) {
            header['X-Access-User'] = loginInfo.memberId;
            header['X-Access-Token'] = loginInfo.token;
        }

        header['content-type'] = 'application/x-www-form-urlencoded';
        header['X-Access-Platform'] = 4;
        header['X-Access-AccountType'] = 0;
        return header;
    }
    _.getImageUrlBySizeType = function (imageUrl, sizeType) {
        if ((imageUrl || '') === '') {
            return imageUrl;
        }
        var source = imageUrl;
        if (source.indexOf('?') > 0) {
            source = source.substr(0, source.indexOf('?'));
        }
        var newImageUrl = source;
        if (!(newImageUrl.indexOf("no_photo") >= 0 || newImageUrl.indexOf('wx.qlogo.cn') >= 0) && newImageUrl.indexOf(".") >= 0) {
            if (sizeType === '大图') {
                newImageUrl += "?x-oss-process=image/resize,m_fill,w_640,h_360,limit_0/auto-orient,0/quality,q_90";
            } else if (sizeType === '中图') {
                newImageUrl += "?x-oss-process=image/resize,m_fill,w_320,h_180,limit_0/auto-orient,0/quality,q_90";
            } else if (sizeType === '小图') {
                newImageUrl += "?x-oss-process=image/resize,m_fill,w_160,h_90,limit_0/auto-orient,0/quality,q_90";
            } else if (sizeType === '方图') {
                newImageUrl += "?x-oss-process=image/resize,m_fill,w_320,h_320,limit_0/auto-orient,0/quality,q_90";
            } else if (sizeType === '原图') {
                newImageUrl += "";
            } else if (sizeType) {
                var arry = sizeType.split('x')
                newImageUrl += `?x-oss-process=image/resize,m_fill,w_${arry[0]},h_${arry[1]},limit_0/auto-orient,0/quality,q_90`;
            }
            return newImageUrl;
        }
        return source;
    }
    _.defaultSuccessHandle = function (data) {
        if (!data) {
            alert.install({
                text: '系统异常，请稍后再试'
            });
            return false;
        }
        if (!data.response) {
            alert.install({
                text: '系统异常，请稍后再试'
            });
            return false;
        }
        if (data.response.message || data.response.errorMessage) {
            el.Message.error(data.response.message || data.response.errorMessage);
            return false;
        } else {
            alert.install({
                text: '系统异常，请稍后再试'
            });
            return false;
        }
    }
    _.defaultErrorHandle = function (data) {
        if (data && data.statusCode == 404) {
            alert.install({
                text: '404'
            });
            return false
        } else {
            alert.install({
                text: '网络连接失败，请检查网络'
            });
            return false
        }
    }
    _.apiUrl = function () {
        if (location.host=='www.angemo.com'||location.host=='angemo.com') {
            return 'https://api.angemo.com'
        } else if (location.host=='www.twototwo.cn'||location.host=='twototwo.cn') {
            return 'https://api.angemo.com'
        } else {
            return 'https://test.api.angemo.com'
        }


    }
})(common);

export default common